export default __webpack_public_path__ + "static/media/hunter (2).045a6e83.jpeg";